export type Solution = {
  id: string;
  name: string;
  logoFile: string;
  description: string;
  url: string;
};

export const SOLUTIONS: Solution[] = [
  {
    id: 'hack-clubs',
    name: 'Hack Clubs!',
    logoFile: 'logo-hack-clubs.png',
    description:
      'O clube de empresários para quem quer crescer junto. Grupos fixos, reuniões mensais presenciais, RPI e HackCoin — desenvolvido exclusivamente para empresários e líderes. Inclui app do clube, mentoria entre pares e acesso à Hack Growth IA, a inteligência artificial do ecossistema alimentada pelo conteúdo autoral da marca.',
    url: 'https://hack.net.br/clubs',
  },
  {
    id: 'hack-sales-performance',
    name: 'Hack Sales Performance',
    logoFile: 'logo-hsp.png',
    description:
      'Transforme seu marketing em um sistema que gera clientes. Diagnóstico estratégico, arquitetura de campanhas, tráfego pago, conteúdo orientado a vendas e gestão com IA — operado por líderes aumentados por inteligência artificial. Para empresas que querem resultado previsível, não campanhas isoladas.',
    url: 'https://hack.net.br/sales-performance',
  },
  {
    id: 'hack-running',
    name: 'Hack Running!',
    logoFile: 'logo-running.png',
    description:
      'Corra com quem pensa como você. Clube de corrida de rua com treinos semanais, assessoria esportiva, nutrição personalizada e comunidade de empresários que buscam performance, disciplina e saúde. Planos individuais e corporativos — do gratuito ao acompanhamento completo.',
    url: 'https://hackrunning.com.br',
  },
  {
    id: 'socialsell',
    name: 'SocialSell',
    logoFile: 'logo-socialsell.png',
    description:
      'Centralize WhatsApp e Instagram em um CRM conversacional com IA. Atendimento unificado para todo o time, funil de vendas visual, agentes de IA que vendem 24/7, disparos em massa e automações sem código. Para empresas que querem parar de perder vendas no caos da desorganização.',
    url: 'https://socialsell.ai',
  },
];
